import React from "react";
import { useRecoilBridgeAcrossReactRoots_UNSTABLE } from "recoil";
import { Global, css } from "@emotion/react";
import DrawingCanvas from "../DrawingCanvas";
import Rectangle from "../Rectangle";

const App: React.FC = () => {
  const RecoilBridge = useRecoilBridgeAcrossReactRoots_UNSTABLE();

  const rects = new Array(30000).fill(0).map((_, i) => {
    const width = Math.random() * 1000;
    const height = Math.random() * 1000;
    const x = Math.random() * 6000;
    const y = Math.random() * 6000;
    return (
      <Rectangle
        color={0xff0000}
        height={height}
        key={i}
        width={width}
        x={x}
        y={y}
      />
    );
  });

  return (
    <>
      <Global
        styles={css`
          html,
          body {
            margin: 0;
            height: 100%;
            overflow: hidden;
          }
        `}
      />
      <DrawingCanvas>
        <RecoilBridge>{rects}</RecoilBridge>
      </DrawingCanvas>
    </>
  );
};

export default App;
